import {getRequest} from "./api";

export const initMenu = (router, store) => {
    if (store.state.routes.length > 0) {
        return;
    }
    getRequest("/system/config/menu").then(data => {
        if (data) {
            let fmtRoutes = formatRoutes(data);
            router.addRoutes(fmtRoutes);
            store.commit('initRoutes', fmtRoutes);
            store.dispatch('connect');
        }
    })
}
export const formatRoutes = (routes) => {
    let fmRoutes = [];
    routes.forEach(router => {
        let {
            path,
            component,
            name,
            meta,
            iconCls,
            children
        } = router;
        if (children && children instanceof Array) {
            children = formatRoutes(children);
        }
        let fmRouter = {
            path: path,
            name: name,
            iconCls: iconCls,
            meta: meta,
            children: children,
            component(resolve) {
                if (component.startsWith("Home")) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith("Emp")) {
                    require(['../views/emp/' + component + '.vue'], resolve);
                } else if (component.startsWith("Person")) {
                    require(['../views/apply/' + component + '.vue'], resolve);
                } else if (component.startsWith("Per")) {
                    require(['../views/per/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sal")) {
                    require(['../views/sal/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sta")) {
                    require(['../views/sta/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sys")) {
                    require(['../views/sys/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sys")) {
                    require(['../views/sys/' + component + '.vue'], resolve);
                } else if (component.startsWith("Project")) {
                    require(['../views/project/' + component + '.vue'], resolve);
                } else if (component.startsWith("Job")) {
                    require(['../views/jobinfo/' + component + '.vue'], resolve);
                } else if (component.startsWith("Intern")) {
                    require(['../views/internship/' + component + '.vue'], resolve);
                } else if (component.startsWith("Goo")) {
                    require(['../views/train/' + component + '.vue'], resolve);
                } else if (component.startsWith("TProjec")) {
                    require(['../views/train/' + component + '.vue'], resolve);
                }else if (component.startsWith("OffLineProjectNew")) {
                    require(['../views/projectNew/' + component + '.vue'], resolve);
                }else if (component.startsWith("Reimbuse")) {
                    require(['../views/reimbuse/' + component + '.vue'], resolve);
                }else if (component.startsWith("Order")) {
                    require(['../views/business/' + component + '.vue'], resolve);
                }else if (component.startsWith("Product")) {
                    require(['../views/product/' + component + '.vue'], resolve);
                }else if (component.startsWith("Site")) {
                    require(['../views/site/' + component + '.vue'], resolve);
                }else if (component.startsWith("Material")) {
                    require(['../views/material/' + component + '.vue'], resolve);
                }else if (component.startsWith("Trade")) {
                    require(['../views/office/' + component + '.vue'], resolve);
                }else if (component.startsWith("Invoice")) {
                    require(['../views/office/' + component + '.vue'], resolve);
                }else if (component.startsWith("Debt")) {
                    require(['../views/office/' + component + '.vue'], resolve);
                }else if (component.startsWith("ImgOrder")) {
                    require(['../views/order/' + component + '.vue'], resolve);
                }else if (component.startsWith("Record")) {
                    require(['../views/apply/' + component + '.vue'], resolve);
                }
            }
        }
        fmRoutes.push(fmRouter);
    })
    return fmRoutes;
}